import { ResellerItem } from '../..';

export interface ProductInformation {
  appId?: string;
  addonId?: string;
  name?: string;
  tagline?: string;
  icon?: string;
  stats?: ProductStats;
  change?: ProductStats;
  growth?: number;
  addons?: ProductInformation[];
  sellingInStore?: boolean;
  expanded?: boolean;
}

export interface ProductStats {
  activations?: number;
  deactivations?: number;
  cancellations?: number;
}

export interface ProductStatsWithId extends ProductStats {
  appId: string;
  editionId: string;
}

export function getMarketplaceRouterLink(product: ResellerItem): string | null {
  if (!product) {
    return null;
  }
  if (product.isCustom) {
    return `/marketplace/products/custom/${product.appId}`;
  }
  if (product.addonId) {
    return `/marketplace/products/${product.appId}/addon/${product.addonId}`;
  }
  return `/marketplace/products/${product.appId}`;
}
